<template>
    <div class="selectContract-box">
        <HeaderNav
            header-title="选择合同信息"
            left-icon-name="3"
            right-icon-name="3"
        ></HeaderNav>
        <span class="back iconfont" @click="handleBack">&#xe607;</span>
        <!-- <div class="search-con">
            <van-search placeholder="请输入搜索关键词"></van-search>
        </div> -->
        <div class="project-list">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                v-if="total"
            >
                <div
                    class="project-item"
                    v-for="item in contractList"
                    :key="item.cvid"
                    @click="chosedContract(item)"
                >
                    <ul>
                        <li>
                            <span class="icon icon1"></span>
                            <span>客户名称：{{ item.client_name }}</span>
                        </li>
                        <li>
                            <span class="icon icon3"></span>
                            <span class="info">工程名称：{{ item.engineering_name }}</span>
                        </li>
                        <li>
                            <span class="icon icon3"></span>
                            <span class="info">签订日期：{{ item.signing_date }}</span>
                        </li>
                        <li>
                            <span class="icon icon2"></span>
                            <span class="info">合同编号：{{ item.contract_number }}</span>
                        </li>
                    </ul>
                </div>
            </van-list>
            <div class="no-data" v-else></div>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Toast } from 'vant';
export default {
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            MobilePhone: '',
            pagetion: {
                pageindex: 0,
                pageSize: 5,
            },
            contractList: [],
            formData: {},
            loading: false,
            finished: false,
            total: true,
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 数据分页加载
        onLoad() {
            this.pagetion.pageindex++;
            if (this.MobilePhone) {
                this.$axios
                    .get('/interfaceApi/sale/contract_manager/get_contract_version_client_page?client_contact_phone='
                    + this.MobilePhone + '&pageindex='
                + this.pagetion.pageindex + '&pageSize=' + this.pagetion.pageSize)
                    .then(res => {
                        this.loading = false;
                        if (res.total) {
                            this.total = true;
                            this.contractList = this.contractList.concat(res.rows);
                            if (this.contractList.length >= res.total) {
                                this.finished = true;
                            }
                        } else {
                            this.total = false;
                            this.finished = true;
                        }
                    }).catch(error => {
                        this.$toast(error.ErrorCode.Message);
                    });
            } else {
                this.loading = false;
                this.$toast('该账号手机号异常，请联系管理员！');
            }

        },
        // 通过code拉取字典信息
        getbycode(num) {
            return this.$axios.get('/interfaceApi/baseinfo/dictionary_config/getbycode/' + num);
        },
        // 选中合同
        async chosedContract(data) {
            if ((data.control_status === 2 || data.control_status === 3) && data.is_can_order === false) {
                this.$toast('当前合同已被管控，不能下单。管控原因：' + data.control_description);
                return;
            }
            this.formData.contract_number = data.contract_number;
            this.formData.client_name = data.client_name;
            this.formData.engineering_name = data.engineering_name;
            this.formData.signing_date = data.signing_date;
            this.$router.isBack = 1;
            this.$router.replace({ name: 'newFeedback', params: { formData: this.formData, type: 'selectedProjectCallBack' } });
            this.$router.go(-1);
        },
        // 返回
        handleBack() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
    created() {
        this.MobilePhone = this.$takeTokenParameters('MobilePhone');
        this.formData = this.$route.params.formData;
    },
    mounted() {
    },
};
</script>
<style lang="stylus" scoped>
.selectContract-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    .back
        position absolute
        top 10rpx
        left 15rpx
        z-index 10000
        color #fff
    .project-list
        height 100%
        overflow-y auto
        overflow-x hidden
        background #F0F0F0
        .project-item
            padding 12rpx
            background #fff
            margin 12rpx 12rpx 0 12rpx
            .icon
                width 18rpx
                height 18rpx
                display inline-block
                vertical-align middle
                margin-right 10rpx
                &:before
                    content ' '
                    width 16rpx
                    height 16rpx
                    display inline-block
                    background-repeat no-repeat
                    background-size 100% 100%
                &.icon1
                    &:before
                        background-image url(./../../../assets/images/icons/icon_gy_3.png)
                &.icon2
                    &:before
                        background-image url(./../../../assets/images/icons/icon_gy_1.png)
                &.icon3
                    &:before
                        background-image url(./../../../assets/images/icons/icon_gy_8.png)
            .info
                color #666666
                font-size 14rpx
            li
                margin-bottom 10rpx
</style>